// src/pages/TrainingLog.js
import React from 'react';

function TrainingLog() {
  return (
    <div className="page">
      {/* Hero-style intro */}
      <div style={{ 
        background: 'linear-gradient(135deg, #f3e8ff 0%, #e9d5ff 100%)',
        padding: '3rem 2rem',
        borderRadius: '20px',
        textAlign: 'center',
        marginBottom: '2rem',
        border: '1px solid rgba(124, 58, 237, 0.1)'
      }}>
        <h1 style={{ color: '#7c3aed', marginBottom: '1rem', fontSize: '2.5rem' }}>📊 DC Hawks Free Training Log</h1>
        <p style={{ fontSize: '1.2rem', color: '#4A5568', maxWidth: '600px', margin: '0 auto' }}>
          Your personal running journal made simple, fun, and functional! 
          Track your journey, celebrate your growth, and reach your goals! 🚀
        </p>
      </div>

      {/* Feature Cards */}
      <div className="highlights">
        <div className="highlight-card">
          <h3>📝 Simple Recording</h3>
          <p>Log workouts and races with just a few clicks. No complicated forms—just the essentials!</p>
        </div>
        
        <div className="highlight-card">
          <h3>🏆 Track Progress</h3>
          <p>Monitor your accomplishments and watch your running journey unfold over time!</p>
        </div>
        
        <div className="highlight-card">
          <h3>🎯 Personal Growth</h3>
          <p>Set goals, celebrate achievements, and build confidence with every logged workout!</p>
        </div>

        <div className="highlight-card">
          <h3>👨‍🏫 Coach Support</h3>
          <p>Team coaches can monitor progress and provide suggestions and encouragement!</p>
        </div>
      </div>

      {/*<div className="content-section">
        <h2>Why Use the DC Hawks Training Log?</h2>
        <p>
          The idea behind our training log tool is to provide athletes with a simple, fun, and 
          functional way to record their workouts and races. It's designed specifically for 
          young runners who want to stay motivated and see their progress in action!
        </p>
        
        <div style={{ 
          background: '#f8fafc', 
          padding: '2rem', 
          borderRadius: '12px', 
          margin: '1.5rem 0',
          border: '2px dashed #7c3aed'
        }}>
          <h3 style={{ color: '#7c3aed', marginBottom: '1rem' }}>🌟 What Makes It Special</h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1rem' }}>
            <div>
              <strong>📈 Monitor & Be Proud:</strong> See your accomplishments displayed clearly and celebrate every milestone!
            </div>
            <div>
              <strong>🎯 Goal Setting:</strong> Set personal targets and track your journey toward achieving them!
            </div>
            <div>
              <strong>🤝 Team Connection:</strong> Share your progress with coaches who care about your development!
            </div>
            <div>
              <strong>🎮 Fun & Engaging:</strong> Designed to make logging workouts enjoyable, not a chore!
            </div>
          </div>
        </div>
      </div>
      */}
      <div className="content-section">
        <h2>Perfect for Young Athletes</h2>
        <p>
          The idea behind the training log tool is to provide athletes with a simple, fun, and 
          functional way to record their workouts and races. It's designed specifically for 
          young runners who want to stay motivated and see their progress in action!
        </p>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '1.5rem', marginTop: '2rem' }}>
          <div style={{ background: '#f0f9ff', padding: '1.5rem', borderRadius: '12px', border: '1px solid #bfdbfe' }}>
            <h4 style={{ color: '#2563eb', marginBottom: '0.5rem' }}>🏃‍♀️ Track Your Runs</h4>
            <p style={{ fontSize: '0.9rem', margin: '0.5rem 0' }}><strong>Easy logging:</strong> Distance, time, effort level</p>
            <p style={{ fontSize: '0.9rem', margin: 0 }}>Record everything from easy jogs to tempo runs and interval workouts!</p>
          </div>
          
          <div style={{ background: '#f0fff4', padding: '1.5rem', borderRadius: '12px', border: '1px solid #c6f6d5' }}>
            <h4 style={{ color: '#38a169', marginBottom: '0.5rem' }}>🏁 Log Your Races</h4>
            <p style={{ fontSize: '0.9rem', margin: '0.5rem 0' }}><strong>Race results:</strong> Times, distances, experiences</p>
            <p style={{ fontSize: '0.9rem', margin: 0 }}>Keep track of every Parkrun, 5K, and cross country race!</p>
          </div>
          
          <div style={{ background: '#fffaf0', padding: '1.5rem', borderRadius: '12px', border: '1px solid #fbd38d' }}>
            <h4 style={{ color: '#d69e2e', marginBottom: '0.5rem' }}>💪 Strength Training</h4>
            <p style={{ fontSize: '0.9rem', margin: '0.5rem 0' }}><strong>Cross-training:</strong> Basketball, soccer, swimming...</p>
            <p style={{ fontSize: '0.9rem', margin: 0 }}>Record all activities that make you a stronger, more complete athlete!</p>
          </div>
          
          <div style={{ background: '#fff5f5', padding: '1.5rem', borderRadius: '12px', border: '1px solid #fed7d7' }}>
            <h4 style={{ color: '#c53030', marginBottom: '0.5rem' }}>📊 See Your Progress</h4>
            <p style={{ fontSize: '0.9rem', margin: '0.5rem 0' }}><strong>Dashboard:</strong> Weekly and monthly summaries</p>
            <p style={{ fontSize: '0.9rem', margin: 0 }}>Watch your fitness journey unfold with clear, motivating visuals!</p>
          </div>
        </div>
      </div>

      {/* 
      <div className="content-section">
        <h2>How Coaches Use the Training Log</h2>
        
        <div style={{ 
          background: 'linear-gradient(135deg, #e6fffa 0%, #f0fff4 100%)',
          padding: '2rem',
          borderRadius: '12px',
          margin: '1.5rem 0'
        }}>
          <h3 style={{ color: '#2A4BA0', marginBottom: '1.5rem', textAlign: 'center' }}>👨‍🏫 Coach's Perspective</h3>
          
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1.5rem' }}>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>📈</div>
              <h4 style={{ color: '#2A4BA0', marginBottom: '0.5rem' }}>Monitor Progress</h4>
              <p style={{ fontSize: '0.9rem', margin: 0 }}>Track each athlete's development and training consistency</p>
            </div>
            
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>💡</div>
              <h4 style={{ color: '#2A4BA0', marginBottom: '0.5rem' }}>Provide Suggestions</h4>
              <p style={{ fontSize: '0.9rem', margin: 0 }}>Offer personalized tips and training adjustments</p>
            </div>
            
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>🎉</div>
              <h4 style={{ color: '#2A4BA0', marginBottom: '0.5rem' }}>Celebrate Wins</h4>
              <p style={{ fontSize: '0.9rem', margin: 0 }}>Recognize achievements and motivate continued growth</p>
            </div>
            
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>🛡️</div>
              <h4 style={{ color: '#2A4BA0', marginBottom: '0.5rem' }}>Prevent Injuries</h4>
              <p style={{ fontSize: '0.9rem', margin: 0 }}>Spot warning signs and ensure healthy training loads</p>
            </div>
          </div>
        </div>
      </div>
      */}
      <div className="content-section">
        <h2>Getting Started is Easy!</h2>
        
        <div style={{ 
          background: '#f5f3ff', 
          padding: '2rem', 
          borderRadius: '12px', 
          margin: '1.5rem 0',
          textAlign: 'center',
          border: '1px solid #c4b5fd'
        }}>
          <h3 style={{ color: '#7c3aed', marginBottom: '1.5rem' }}>🚀 Three Simple Steps</h3>
          
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '2rem' }}>
            <div>
              <div style={{ 
                width: '60px', 
                height: '60px', 
                background: '#7c3aed', 
                color: 'white', 
                borderRadius: '50%', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center', 
                fontSize: '1.5rem', 
                fontWeight: 'bold',
                margin: '0 auto 1rem auto'
              }}>1</div>
              <h4 style={{ color: '#7c3aed', marginBottom: '0.5rem' }}>Click the Link</h4>
              <p style={{ fontSize: '0.9rem', margin: 0 }}>Access our training log app with one simple click</p>
            </div>
            
            <div>
              <div style={{ 
                width: '60px', 
                height: '60px', 
                background: '#7c3aed', 
                color: 'white', 
                borderRadius: '50%', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center', 
                fontSize: '1.5rem', 
                fontWeight: 'bold',
                margin: '0 auto 1rem auto'
              }}>2</div>
              <h4 style={{ color: '#7c3aed', marginBottom: '0.5rem' }}>Create Account</h4>
              <p style={{ fontSize: '0.9rem', margin: 0 }}>Quick and easy signup—no complicated setup required</p>
            </div>
            
            <div>
              <div style={{ 
                width: '60px', 
                height: '60px', 
                background: '#7c3aed', 
                color: 'white', 
                borderRadius: '50%', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center', 
                fontSize: '1.5rem', 
                fontWeight: 'bold',
                margin: '0 auto 1rem auto'
              }}>3</div>
              <h4 style={{ color: '#7c3aed', marginBottom: '0.5rem' }}>Have Fun Running!</h4>
              <p style={{ fontSize: '0.9rem', margin: 0 }}>Start logging your workouts and watch your progress soar!</p>
            </div>
          </div>
        </div>

        {/* <p style={{ textAlign: 'center', fontSize: '1.1rem', color: '#4A5568', marginTop: '2rem' }}>
          <strong>No special instructions needed—it's designed to be intuitive and fun!</strong>
        </p> */}
      </div>

      <div className="cta-section">
        <h2>Ready to Start Your Training Log Journey? 📊</h2>
        {/*<p>
          Join your teammates in tracking your running progress! The training log is 
          designed specifically for DC Hawks athletes who want to see their growth 
          and stay motivated on their running journey.
        </p>
        */}
        <a 
          href="https://dc-hawks-training-log.vercel.app" 
          target="_blank"
          rel="noopener noreferrer"
          className="cta-button"
        >
          Launch Training Log App 🚀
        </a>
        <p style={{ fontSize: '0.9rem', color: '#666', marginTop: '1rem' }}>
        </p>
      </div>
    </div>
  );
}

export default TrainingLog;